import React from "react";
import Header from './Layout/Header';
import Sidebar from './Layout/Sidebar';
import './layout.css';

const Layout = ({ children, logout, isActive, toggleSidebar, closeSidebar }) => {
    return (
        <>
            <Header toggleSidebar={toggleSidebar} logout={logout} isActive={isActive} closeSidebar={closeSidebar} />
            <Sidebar isActive={isActive} logout={logout} closeSidebar={closeSidebar} />
            <div className='main-container-admin'>
                {children}
            </div>
        </>
    );
};

export default Layout;
